module.exports = __webpack_public_path__ + "static/media/christmas_2_bottom.ddbc4c6c.svg";